import React from 'react';
import ReactDOM from 'react-dom';
import { createStore, applyMiddleware, compose } from 'redux';
import { Provider } from 'react-redux';
import { ConnectedRouter, routerMiddleware } from 'react-router-redux';
import createHistory from 'history/createBrowserHistory';
import createSagaMiddleware from 'redux-saga';

import App from './app/App';
import rootReducer from './reducers';
import rootSaga from './sagas';

// import css here
import './index.css';

// initial state of the app as empty object
const initialState = {};
const history = createHistory();

// create the saga middleware
const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware, routerMiddleware(history)];
const enhancers = [applyMiddleware(...middlewares)];
/* eslint-disable */

// dev tools middleware
const composeEnhancers =
  process.env.NODE_ENV !== 'production' &&
    typeof window === 'object' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__
    ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
      shouldHotReload: false,
    })
    : compose;

const store = createStore(
  rootReducer,
  initialState,
  composeEnhancers(...enhancers),
);

/**
 * Refer to this link for more about hot reloading of sagas
 * https://stackoverflow.com/questions/37148592/redux-saga-hot-reloading
 */



if (module.hot) {
  // Enable Webpack hot module replacement for reducers
  module.hot.accept('./reducers', () => {
    const nextRootReducer = require('./reducers');
    store.replaceReducer(nextRootReducer);
  });

  // let sagaTask = sagaMiddleware.run(function* () {
  //   yield rootSaga();
  // });

  // module.hot.accept('./sagas', () => {
  //   const getNewSagas = require('./sagas');
  //   sagaTask.cancel()
  //   sagaTask.done.then(() => {
  //     sagaTask = sagaMiddleware.run(function* replacedSaga(action) {
  //       yield getNewSagas()
  //     })
  //   })
  // })
}

// run the saga
store.runSaga = sagaMiddleware.run(rootSaga, store.dispatch);

ReactDOM.render(
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <App />
    </ConnectedRouter>
  </Provider>,
  document.getElementById('root'),
);

/* eslint-enable react/jsx-filename-extension */

if (module.hot) {
  module.hot.accept('./app/App', () => {
    const NextApp = require('./app/App').default;
    ReactDOM.render(
      <Provider store={store}>
        <ConnectedRouter history={history}>
          <NextApp />
        </ConnectedRouter>
      </Provider>,
      document.getElementById('root'),
    );
  });
}
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/index.js